import { Fragment, h } from "preact";
import { useState, useEffect, useRef } from "preact/hooks";
import {
	Button,
	Box,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
	Slide,
	Stack,
	TextField,
	ToggleButtonGroup,
	ToggleButton,
	Typography,
} from "@mui/material";

import { ValidateEmail } from "../Common/helpers";

export default function SellerBuyerOnboardingDialog(props) {
	console.log("SellerBuyerOnboardingDialog", props)
	const [state, setState] = useState({ init: false, nextStep: 1, form: { uid: props.state.uid } });
	const handleClose = () => {
		setState({ init: false, nextStep: 1, form: {} });
		props.onClose();
	};

	const handleChange = (event) => {

		setState({ ...state, form: { ...state.form, [event.target.name]: event.target.value } });
	};
	const checkPPStep1 = () => {
		return ValidateEmail(state.form.email) &&
			state.form.firstname.length > 0 &&
			state.form.lastname.length > 0 &&
			["M", "Mme"].includes(state.form.gender);
	};
	const checkPPStep2 = () => {
		return state.form.firstname2.length > 0 &&
			state.form.lastname2.length > 0 &&
			["M", "Mme"].includes(state.form.gender2);
	};
	const checkPPStep3 = () => {
		return state.form.firstname3.length > 0 &&
			state.form.lastname3.length > 0 &&
			["M", "Mme"].includes(state.form.gender3);
	};
	const urltype = (side) => {
		if (side === "VN") return "34ecfcb39e70401da24338d86945052f";

		if (side === "AC") return "26941389c5334a5bbd1d64933b4c0642";

		return "";
	};
	const manageSubmit = () => {
		console.log("manageSubmit", state);

		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify({ ...state.form, uid: props.state.uid, src: props.state.src }),
		};
		fetch("/api/" + urltype(props.state.side), requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.reload();
						break;

					case "err":
						break;
					default:
						break;
				}
			});
		handleClose();
	};
	useEffect(() => {
		console.log("useEffect", state)
		if (window.location.href.startsWith("http://localhost") && state.form.email === undefined) {
			console.log("init form with values")
			setState({
				...state, form: {
					email: "guillaume.besse+bk" + Math.floor(Math.random() * 1000000) + "@telemetis.com",
					firstname: "",//"Guigui_1_" + Math.floor(Math.random() * 10000),
					lastname: "Besse_1_" + Math.floor(Math.random() * 10000),
					firstname2: "Guigui2 (PRXR)",
					lastname2: "Besse2",
					email2: "guillaume.besse+bk" + Math.floor(Math.random() * 1000000) + "@telemetis.com",
					firstname3: "Guigui3 (LNKD)",
					lastname3: "Besse3",
					gender: undefined,
					proxier: undefined,
					union: undefined,
					gender: "M",
					gender2: "M"
				}
			});
		} else {
			setState({
				...state,
				form: {
					proxier: undefined,
					union: undefined,
					email: undefined,
					firstname: undefined,
					lastname: undefined,
					firstname2: undefined,
					lastname2: undefined,
					email2: undefined,
					firstname3: undefined,
					lastname3: undefined,
					gender: "M",
					gender2: "M"
				}
			});
		}
	}, []);

	const stepsPP = () => {

		if (state.form.proxier === undefined) { return 2 }


		if (state.form.proxier === "N" && !checkPPStep1()) { return 3 }
		if (state.nextStep == 3 && checkPPStep1()) { return 4 }
		if (state.nextStep == 4) { return 4 }




		if (state.form.proxier === "O" && !checkPPStep1()) { return 5 }
		if (state.nextStep == 5 && (checkPPStep1() || state.form.proxier.length > 1)) { return 6 }

		if (state.nextStep == 6 && (checkPPStep1() || state.form.proxier.length > 1)) { return 6 }
		if (state.nextStep == 7 && !checkPPStep2()) { return 7 }
		if (state.nextStep == 7 && checkPPStep2()) { return 8 }
		if (state.nextStep == 8 && !checkPPStep2()) { return 7 }

		if (state.nextStep == 8) { return 8 }

		if (state.nextStep == 9) { return 10 }


		return 10;
	}
	const stepsPM = () => {
		if (state.nextStep == 1) {
			setState({ ...state, form: { ...state.form, proxier: "O" } });
			return 20
		}
		if (state.nextStep == 20 && (checkPPStep1() || state.form.proxier.length > 1)) { return 21 }
		if (state.nextStep == 20) { return 20 }
		if (state.nextStep == 21) { return 21 }
		if (state.nextStep == 22 && state.form.lastname2.length > 0) { return 23 }


		if (state.nextStep == 23) { return 23 }


		return 23;
	}
	useEffect(() => {
		console.log("check state form change", state)


		var nextStep = 0;

		switch (state.form.type) {
			case "PP":

				nextStep = stepsPP();

				break;
			case "PM":

				nextStep = stepsPM();

				break;
			default:
				nextStep = 1;

				break;
		}

		if (state.nextStep !== nextStep) {

			setState((state) => ({ ...state, nextStep: nextStep }));
		} else {
			console.log("no change state 2", { nextStep: nextStep })
		}



	}, [state.form]);
	const containerRef = useRef(null);
	const formContainer = (
		<Stack spacing={2}>
			
			{state.form.type === "PP" &&
				<Fragment>
					{state.nextStep === 2 &&
						<Stack justifyContent={"space-between"} alignItems={"flex-start"} >
							<Stack justifyContent={"space-between"} alignItems={"center"} flexDirection={"row"}>
								<Typography variant="body1">Le vendeur est un particulier</Typography>
								<Button onClick={() => { setState({ ...state, form: { ...state.form, proxier: undefined, type: undefined }, init: false }) }}>Modifier</Button>
							</Stack>
							<Stack justifyContent={"space-between"} alignItems={"center"} spacing={2} >
								<Typography variant="h5">Le vendeur est-il représenté par une tierce personne ?</Typography>

								<ToggleButtonGroup
									color="primary"
									value={state.form.proxier}
									exclusive
									onChange={handleChange}
									size="large"
								>
									<ToggleButton value="O" name="proxier">Oui</ToggleButton>
									<ToggleButton value="N" name="proxier">Non</ToggleButton>

								</ToggleButtonGroup>
								<Typography variant="caption">Dans le cas d'un mineur, d'une personne protégée...</Typography>
							</Stack>
						</Stack>
					}
					{(state.nextStep === 3 || state.nextStep === 4) &&
						<Fragment>
							<Stack justifyContent={"space-between"} alignItems={"center"} flexDirection={"row"}>
								<Typography variant="body1">Le vendeur est un particulier</Typography>
								<Button onClick={() => { setState({ ...state, form: { ...state.form, proxier: undefined, type: undefined }, init: false }) }}>Modifier</Button>
							</Stack>
							<Stack justifyContent={"space-between"} alignItems={"center"} flexDirection={"row"}>
								<Typography variant="body1">Le vendeur n'est pas représenté par une tierce personne</Typography>
								<Button onClick={() => { setState({ ...state, form: { ...state.form, proxier: undefined } }) }}>Modifier</Button>
							</Stack>

							<Stack justifyContent={"space-between"} alignItems={"center"} flexDirection={"row"}>
								<FormControl component="fieldset">
									<RadioGroup
										row
										aria-label="gender"
										name="gender"
										defaultValue={state.form.gender}
										onChange={handleChange}
										dense
										value={state.form.gender}
									>
										<FormControlLabel value="Mme" control={<Radio color="primary" />} label="Mme" />
										<FormControlLabel value="M" control={<Radio color="primary" />} label="M" />
									</RadioGroup>
								</FormControl>
								<TextField
									id="firstname"
									name="firstname"
									variant="outlined"
									style={{
										marginLeft: 0,
										marginRight: 0,
									}}
									placeholder="Prénom"
									fullWidth
									margin="dense"
									size="small"
									value={state.form.firstname}
									onChange={handleChange}
								/>
								{/* {state.form.firstname && <span onClick={() => {
									setState({ ...state, form: { ...state.form, lastname: state.form.firstname, email: "guillaume.besse+" + state.form.firstname + "@telemetis.com" } })
								}}>&nbsp;&nbsp;</span>} */}
							</Stack>
							<TextField
								id="lastname"
								name="lastname"
								variant="outlined"
								style={{
									marginLeft: 0,
									marginRight: 10,
								}}
								placeholder="Nom"
								fullWidth
								margin="dense"
								size="small"
								value={state.form.lastname}
								onChange={handleChange}
							/>
							<TextField
								id="email"
								name="email"
								variant="outlined"
								style={{
									marginLeft: 0,
									marginRight: 10,
								}}
								placeholder="Email"
								fullWidth
								margin="dense"
								size="small"
								value={state.form.email}
								onChange={handleChange}
							/>

						</Fragment>
					}
					{(state.nextStep === 5 || state.nextStep === 6) &&
						<Fragment>
							<Stack justifyContent={"space-between"} alignItems={"center"} flexDirection={"row"}>
								<Typography variant="body1">Le vendeur est un particulier</Typography>
								<Button onClick={() => { setState({ ...state, form: { ...state.form, proxier: undefined, type: undefined }, init: false }) }}>Modifier</Button>
							</Stack>

							<Fragment>
								<Stack justifyContent={"space-between"} alignItems={"center"} flexDirection={"row"}>
									<Typography variant="body1">Le vendeur est représenté par une tierce personne</Typography>
									<Button onClick={() => { setState({ ...state, form: { ...state.form, proxier: undefined } }) }}>Modifier</Button>
								</Stack>
								<Typography variant="h5">Coordonnées du représentant</Typography>
								{props.state.users && props.state.users.length > 0 && <TextField
									id="proxier"
									name="proxier"
									select
									value={state.form.proxier}
									onChange={handleChange}
									SelectProps={{
										native: true,
									}}
									variant="standard"
								>
									{" "}
									<option value={"O"}>
										<em>J'inscris le représentant</em>
									</option>
									{props.state.users &&
										props.state.users.map((u) => {
											return (
												<option value={u.uid}>

													{u.name}
												</option>
											);
										})}
								</TextField>}
							</Fragment>

							{state.form.proxier === "O" && <Fragment><Stack justifyContent={"space-between"} alignItems={"center"} flexDirection={"row"}>
								<FormControl component="fieldset">
									<RadioGroup
										row
										aria-label="gender"
										name="gender"
										defaultValue={state.form.gender}
										onChange={handleChange}
										dense
										value={state.form.gender}
									>
										<FormControlLabel value="Mme" control={<Radio color="primary" />} label="Mme" />
										<FormControlLabel value="M" control={<Radio color="primary" />} label="M" />
									</RadioGroup>
								</FormControl>
								<TextField
									id="firstname"
									name="firstname"
									variant="outlined"
									style={{
										marginLeft: 0,
										marginRight: 0,
									}}
									placeholder="Prénom"
									fullWidth
									margin="dense"
									size="small"
									value={state.form.firstname}
									onChange={handleChange}
								/>
								{/* {state.form.firstname && <span onClick={() => {
									setState({ ...state, form: { ...state.form, lastname: state.form.firstname, email: "guillaume.besse+" + state.form.firstname + "@telemetis.com" } })
								}}>&nbsp;&nbsp;</span>} */}
							</Stack>
								<TextField
									id="lastname"
									name="lastname"
									variant="outlined"
									style={{
										marginLeft: 0,
										marginRight: 10,
									}}
									placeholder="Nom"
									fullWidth
									margin="dense"
									size="small"
									value={state.form.lastname}
									onChange={handleChange}
								/>
								<TextField
									id="email"
									name="email"
									variant="outlined"
									style={{
										marginLeft: 0,
										marginRight: 10,
									}}
									placeholder="Email"
									fullWidth
									margin="dense"
									size="small"
									value={state.form.email}
									onChange={handleChange}
								/></Fragment>}
						</Fragment>
					}

					{(state.nextStep === 9 || state.nextStep === 10) &&
						<Fragment>
							<Stack justifyContent={"space-between"} alignItems={"center"} flexDirection={"row"}>
								<Typography variant="body1">Le vendeur est un particulier</Typography>
								<Button onClick={() => { setState({ ...state, form: { ...state.form, proxier: undefined, type: undefined }, init: false }) }}>Modifier</Button>
							</Stack>
							{state.form.proxier === "N" && <Stack justifyContent={"space-between"} alignItems={"center"} flexDirection={"row"}>
								<Typography variant="body1">Le vendeur n'est pas représenté par une tierce personne</Typography>
								<Button onClick={() => { setState({ ...state, form: { ...state.form, proxier: undefined } }) }}>Modifier</Button>
							</Stack>}
							{state.form.proxier === "O" && <Fragment>
								<Stack justifyContent={"space-between"} alignItems={"center"} flexDirection={"row"}>
									<Typography variant="body1">Le vendeur est représenté par une tierce personne</Typography>
									<Button onClick={() => { setState({ ...state, form: { ...state.form, proxier: undefined } }) }}>Modifier</Button>
								</Stack>

							</Fragment>
							}
							{/* <Typography variant="h5">Le conjoint est-il également vendeur ?</Typography>
							<Typography variant="body1">Une indivision ou un contrat de mariage par exemple</Typography>
							<ToggleButtonGroup
								color="primary"
								value={state.form.union}
								exclusive
								onChange={handleChange}
								size="small"
							>
								<ToggleButton value="O" name="union">Oui</ToggleButton>
								<ToggleButton value="N" name="union">Non</ToggleButton>
								<ToggleButton value="P" name="union">Pas de conjoint</ToggleButton>
								<ToggleButton value="?" name="union">Ne sais pas</ToggleButton>

							</ToggleButtonGroup> */}

						</Fragment>
					}
					{(state.nextStep === 7 || state.nextStep === 8) &&
						<Fragment>
							<Stack justifyContent={"space-between"} alignItems={"center"} flexDirection={"row"}>
								<Typography variant="body1">Le vendeur est un particulier</Typography>
								<Button onClick={() => { setState({ ...state, form: { ...state.form, proxier: undefined, type: undefined }, init: false }) }}>Modifier</Button>
							</Stack>
							<Stack justifyContent={"space-between"} alignItems={"center"} flexDirection={"row"}>
								<Typography variant="body1">Le vendeur est représenté par une tierce personne</Typography>
								<Button onClick={() => { setState({ ...state, form: { ...state.form, proxier: undefined } }) }}>Modifier</Button>
							</Stack>
							<Typography variant="h5">Coordonnées du vendeur représenté</Typography>
							<Stack justifyContent={"space-between"} alignItems={"center"} flexDirection={"row"}>
								<FormControl component="fieldset">
									<RadioGroup
										row
										aria-label="gender"
										name="gender2"
										defaultValue={state.form.gender2}
										onChange={handleChange}
										value={state.form.gender2}
										dense
									>
										<FormControlLabel value="Mme" control={<Radio color="primary" />} label="Mme" />
										<FormControlLabel value="M" control={<Radio color="primary" />} label="M" />
									</RadioGroup>
								</FormControl>
								<TextField
									id="firstname2"
									name="firstname2"
									variant="outlined"
									style={{
										marginLeft: 0,
										marginRight: 0,
									}}
									placeholder="Prénom"
									fullWidth
									margin="dense"
									size="small"
									value={state.form.firstname2}
									onChange={handleChange}
								/>
							</Stack>
							<TextField
								id="lastname2"
								name="lastname2"
								variant="outlined"
								style={{
									marginLeft: 0,
									marginRight: 10,
								}}
								placeholder="Nom"
								fullWidth
								margin="dense"
								size="small"
								value={state.form.lastname2}
								onChange={handleChange}
							/>
						</Fragment>

					}

				</Fragment>
			}
			{
				state.form.type === "PM" &&
				<Fragment>
					{(state.nextStep === 20 || state.nextStep === 21) &&
						<Fragment>
							<Stack justifyContent={"space-between"} alignItems={"center"} flexDirection={"row"}>
								<Typography variant="body1">Le vendeur est une personne morale</Typography>
								<Button onClick={() => { setState({ ...state, form: { ...state.form, proxier: undefined, type: undefined }, init: false }) }}>Modifier</Button>
							</Stack>
							<Typography variant="h5">Coordonnées du représentant</Typography>
							{props.state.users && props.state.users.length > 0 && <TextField
								id="proxier"
								name="proxier"
								select
								value={state.form.proxier}
								onChange={handleChange}
								SelectProps={{
									native: true,
								}}
								variant="standard"
							>
								{" "}
								<option value={"O"}>
									<em>{state.form.type === "PP" ? "Oui, je l'inscris" : "Un nouveau participant"}</em>
								</option>
								{props.state.users &&
									props.state.users.map((u) => {
										return (
											<option value={u.uid}>

												{u.name}
											</option>
										);
									})}
							</TextField>}

							{(state.form.proxier === undefined || state.form.proxier === "O") && <Fragment><Stack justifyContent={"space-between"} alignItems={"center"} flexDirection={"row"}>
								<FormControl component="fieldset">
									<RadioGroup
										row
										aria-label="gender"
										name="gender"
										defaultValue={state.form.gender}
										onChange={handleChange}
										dense
										value={state.form.gender}
									>
										<FormControlLabel value="Mme" control={<Radio color="primary" />} label="Mme" />
										<FormControlLabel value="M" control={<Radio color="primary" />} label="M" />
									</RadioGroup>
								</FormControl>
								<TextField
									id="firstname"
									name="firstname"
									variant="outlined"
									style={{
										marginLeft: 0,
										marginRight: 0,
									}}
									placeholder="Prénom"
									fullWidth
									margin="dense"
									size="small"
									value={state.form.firstname}
									onChange={handleChange}
								/>
							</Stack>
								<TextField
									id="lastname"
									name="lastname"
									variant="outlined"
									style={{
										marginLeft: 0,
										marginRight: 10,
									}}
									placeholder="Nom"
									fullWidth
									margin="dense"
									size="small"
									value={state.form.lastname}
									onChange={handleChange}
								/>
								<TextField
									id="email"
									name="email"
									variant="outlined"
									style={{
										marginLeft: 0,
										marginRight: 10,
									}}
									placeholder="Email"
									fullWidth
									margin="dense"
									size="small"
									value={state.form.email}
									onChange={handleChange}
								/>
							</Fragment>}
						</Fragment>
					}
					{(state.nextStep === 22 || state.nextStep === 23) &&
						<Stack spacing={1}>
							<Box justifyContent={"space-between"} alignItems={"center"}>
								<Box>
									<Typography variant="body1">Le vendeur est une société</Typography>
								</Box>
								<Box>
									<Button onClick={() => { setState({ ...state, form: { ...state.form, proxier: undefined, type: undefined }, init: false }) }}>Modifier</Button>
								</Box>
							</Box>

							<Typography variant="h5">Raison sociale de la société</Typography>

							<TextField
								id="lastname2"
								name="lastname2"
								variant="outlined"
								style={{
									marginLeft: 0,
									marginRight: 10,
								}}
								placeholder="Raison sociale"
								fullWidth
								margin="dense"
								size="small"
								value={state.form.lastname2}
								onChange={handleChange}
							/>
						</Stack>

					}
				</Fragment>
			}
		</Stack >)
	console.log("render", state)
	return (
		<Dialog aria-labelledby="add-user-dialog" onClose={handleClose} open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5">Inviter un {props.state.side == "VN" ? "propriétaire" : "acquéreur"} </Typography>
			</DialogTitle>
			<DialogContent dividers ref={containerRef}>
				{state.nextStep === 1 &&
					<Stack spacing={2} justifyContent={"center"} alignItems={"center"}>
						<Typography variant="h5">{props.state.side == "VN" ? "Le vendeur" : "L'acquéreur"} est-il un particulier ?</Typography>

						{/* <Button variant="contained" onClick={() => { setState({ ...state, form: { ...state.form, type: "PP" }, init: true }) }}>Oui</Button>
						<Button variant="contained" onClick={() => { setState({ ...state, form: { ...state.form, type: "PM" }, init: true }) }}>Non</Button> */}
						<ToggleButtonGroup
							color="primary"
							value={state.form.type}
							exclusive
							onChange={handleChange}
							size="large"
						>
							<ToggleButton value="PP" name="type">Oui</ToggleButton>
							<ToggleButton value="PM" name="type">Non</ToggleButton>

						</ToggleButtonGroup>
						<Typography variant="h5">{props.state.side == "VN" ? "Le vendeur" : "L'acquéreur"} est une SCI, une entreprise...</Typography>
					</Stack>
				}
				<Slide direction="left" in={true} container={containerRef.current}>
					{formContainer}
				</Slide>
			</DialogContent>
			<DialogActions>
				<Stack flexDirection={"row"} justifyContent={"space-between"} style="width: 100%">
					<Button variant="outlined" onClick={handleClose}>
						Annuler
					</Button>
					{(state.nextStep === 6 || state.nextStep === 21) && <Button variant="contained" onClick={() => setState({ ...state, nextStep: (state.nextStep + 1) })} >
						Suivant
					</Button>}
					{/* {(state.nextStep === 4) && <Button variant="contained" onClick={() => setState({ ...state, nextStep: 9 })} >
						Suivant
					</Button>} */}
					{/* {( || state.nextStep === 7) && <Button variant="contained" onClick={manageSubmit}  >
						Inviter
					</Button>} */}
					{(state.nextStep === 4 || state.nextStep === 8 || state.nextStep === 10 || state.nextStep === 23) && <Button variant="contained" onClick={manageSubmit} >
						Inviter
					</Button>}
				</Stack>
			</DialogActions>
		</Dialog>
	);
}
